import {useSelector} from "react-redux";
import {convertMilliseconds, convertToTimeString} from "utils";
import View from "./View";
import {useState, useEffect} from "react";
import {getIpxWorldUserRank, upsertIpxWorldHistory} from "api-v3";

export default function Container() {
  const gameState = useSelector(state => state.game);
  const [currentRecord, setCurrentRecord] = useState();
  const [bestRecord, setBestRecord] = useState();

  useEffect(() => {
    if (gameState.messageFromGame?.record) {
      const record = convertRecord(gameState.messageFromGame.record * 1000);
      const updateRunnerzRecord = async record => {
        try {
          await upsertIpxWorldHistory({
            worldType: "DONUTDRIVE",
            time: record,
          });
          const res = await getIpxWorldUserRank({worldType: "DONUTDRIVE"});
          setBestRecord(res.message.time);
        } catch (error) {
          console.log(error);
        }
      };

      updateRunnerzRecord(record);
      setCurrentRecord(record);
    }
  }, [gameState]);

  const convertRecord = record => {
    if (!record || record >= 3600000) return "-";
    const {minutes, seconds, milliseconds} = convertMilliseconds(record);
    return convertToTimeString([minutes, seconds, milliseconds]);
  };

  return <View currentRecord={currentRecord} bestRecord={bestRecord} />;
}
